// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__QKh7D","title":"ClientCherryInfo_title__3g4cJ","itemText":"ClientCherryInfo_itemText__4YSjY"};